import { forecastByClaim, rootForecast } from "./forecasts";

export function predictLabel(raw: string, _max = 120): string {
  const t = (raw || "").trim();
  if (!t) return rootForecast("pulse").claim;
  const exact = forecastByClaim(t);
  if (exact) return exact.claim;
  return rootForecast(t).claim;
}

export function timeRole(layer: "inner" | "middle" | "outer"): string {
  if (layer === "inner") return "Now";
  if (layer === "middle") return "Next";
  return "Later";
}
